import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray, titles } from '../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	databoard: {
		width: '100%',
		height: 'auto',
		background: 'transparent',
	},
	databoardBody: {
		height: 'auto',
		overflow: 'visible',
		backgroundColor: 'transparent',
		border: 'none',
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '80px 20px',
	},
	loadMoreContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: '16px',
	},
	dataGrid: {
		width: '100%',
	},
	columnHeader: {
		padding: '12px 16px',
		fontWeight: 600,
		color: titles,
		borderBottom: `1px solid ${charmGray}`,
		backgroundColor: '#fafafa',
	},
	sortTrigger: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		cursor: 'pointer',
		':hover': {
			color: brandPrimary,
		},
	},
	sortIcon: {
		transition: 'transform 0.2s ease',
		transform: 'rotate(0deg)',
	},
	sortIconFlipped: {
		transform: 'rotate(180deg)',
	},
	sortMenu: {
		backgroundColor: 'white',
		border: `1px solid ${charmGray}`,
		borderRadius: '4px',
		padding: '8px 0',
		minWidth: '150px',
	},
	sortMenuItem: {
		padding: '8px 16px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	emptyStateContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '200px',
	},
	placeholder: {
		padding: '40px 20px',
		textAlign: 'center',
	},
});
